import './types';
export { useTranslation } from './useTranslation';

export type Language = 'fr' | 'en';

export interface Translations {
  [key: string]: {
    fr: string;
    en: string;
  };
}

// Default language (French for West Africa)
export const DEFAULT_LANGUAGE: Language = 'fr';

// Available languages
export const SUPPORTED_LANGUAGES: { [key in Language]: { name: string; nativeName: string; flag: string } } = {
  fr: {
    name: 'French',
    nativeName: 'Français',
    flag: '🇫🇷'
  },
  en: {
    name: 'English',
    nativeName: 'English',
    flag: '🇬🇧'
  }
};

// Language detection
export const detectLanguage = (): Language => {
  // Check localStorage first
  const savedLang = localStorage.getItem('language') as Language;
  if (savedLang && SUPPORTED_LANGUAGES[savedLang]) {
    return savedLang;
  }

  // Check browser language
  const browserLang = navigator.language.split('-')[0] as Language;
  if (browserLang && SUPPORTED_LANGUAGES[browserLang]) {
    return browserLang;
  }

  // Default to French for West Africa
  return DEFAULT_LANGUAGE;
};

// Language switching
export const setLanguage = (language: Language): void => {
  if (SUPPORTED_LANGUAGES[language]) {
    localStorage.setItem('language', language);
    // Dispatch custom event to notify components of language change
    window.dispatchEvent(new CustomEvent<{ language: Language }>('languageChanged', { detail: { language } }));
  }
};

// Get current language
export const getCurrentLanguage = (): Language => {
  return detectLanguage();
};

// Get current language without detection (for performance)
export const getCurrentLanguageDirect = (): Language => {
  const savedLang = localStorage.getItem('language') as Language;
  if (savedLang && SUPPORTED_LANGUAGES[savedLang]) {
    return savedLang;
  }
  return DEFAULT_LANGUAGE;
};
